<template>
  <el-dialog
    v-if="visible"
    visible
    show-close
    width="1000px"
    :title="$l('dialog_title_editVehicle') || '运输车辆'"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :hxJdVehicleCode="hxJdVehicleCode"
      :hxShipmentJdCode="hxShipmentJdCode"
      @close="close()"
      @reload="$emit('reload')"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="$refs.main.save()">
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: () => false },
    hxJdVehicleCode: { type: String, default: '' },
    hxShipmentJdCode: { type: String, default: '' },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
